import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BasicInfoComponent } from './basic-info/basic-info.component';
import { ReactiveFormsModule } from '@angular/forms';
import {AngularFireModule} from 'angularfire2';
import {AngularFireDatabaseModule} from 'angularfire2/database';
import {AngularFireAuthModule} from 'angularfire2/auth';
import {LoginComponent} from './login/login.component';
import {routes} from './app.routes';
import {AuthGuard} from "./auth-gaurd.service";
import { LandingPageComponent } from './landing-page/landing-page.component';

export const firebaseConfig = {
  apiKey: 'AIzaSyAMCFvSIr6gEs_V9hv7tV44GqkQUxsU1gI',
  authDomain: 'ecell-hcst-farah.firebaseapp.com',
  databaseURL: 'https://ecell-hcst-farah.firebaseio.com',
  projectId: 'ecell-hcst-farah',
  storageBucket: 'ecell-hcst-farah.appspot.com',
  messagingSenderId: '800641355602'
}

@NgModule({
  declarations: [
    AppComponent,
    BasicInfoComponent,
    LoginComponent,
    LandingPageComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    routes
  ],
  providers: [AuthGuard],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Projects/angular/ecell-hcst/src/app/app.module.ts